







import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";

@Component
export default class ScriptGroupKeyEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  isAlreadyLayouted: boolean;

  @Prop()
  commonComponents: CommonComponentsContainer;

  scriptGroupKey: string = "";

  mounted() {
    this.scriptGroupKey = this.editingSource;
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: string, oldValue: string): void {
    this.scriptGroupKey = newValue;
  }

  @Watch("scriptGroupKey")
  async onScriptGroupKeyUpdated(newValue: string, oldValue: string): Promise<void> {
    if (this.editingSource === newValue) {
      return;
    }
    const scriptGroupEditor = this.commonComponents.getScriptGroupEditor();
    if (newValue === "") {
      await scriptGroupEditor.alertEmptyKey();
      this.scriptGroupKey = oldValue;
      return;
    }
    if (scriptGroupEditor.containsSameKey(newValue)) {
      if (await scriptGroupEditor.confirmCreateUniqueKey()) {
        this.updateKey(scriptGroupEditor.createUniqueKey(newValue));
      } else {
        this.scriptGroupKey = oldValue;
        return;
      }
    }
    this.updateKey(newValue);
  }

  private updateKey(key: string) {
    if (this.isAlreadyLayouted) {
      this.commonComponents.getScriptGroupEditor().updateKey(this.editingSource, key);
    } else {
      this.editingSource = key;
    }
  }
}
